"use strict";
import {http} from '../../../core';
import Config from "../../../app.config";
const RequestService = http.create();


export default {
    //一线事件管理报表
    //一线团队受理+处理事件统计  发送时间参数获取数据
    getAcceptEvents(params){
        return  RequestService.get('event/event_handle_statistics',params)
    },
    //客户满意度合格率
    getSatisficationRate(params){
        return RequestService.get('event/event_satisfaction_statistics',params)
    },
    //超出SLA的事件的数量
    getExceedSLA(params){
        return RequestService.get('event/event_sla_statistics',params)
    },
}
